module.exports = __webpack_public_path__ + "static/img/dz11.620bc98a.png";